import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const rgpdmodule = {
	state: {
		hasrpgd : Boolean(window.localStorage.getItem('hasToAcceptRGPD')),
		textRGPD : ''
	},
	getters: {	
		gethasRGPD : state => state.hasrpgd,
		gettextRGPD : state => state.textRGPD
	},
	actions: {
		turnOnRGPD({commit}){
			commit('setRGPD',true);
			window.localStorage.setItem('hasToAcceptRGPD', true);
		},
		turnOffRGPD({commit}){
			commit('setRGPD',false);
			window.localStorage.removeItem('hasToAcceptRGPD');
		},
		requestRGPD({commit}){
			return new Promise((resolve, reject) => {
				axios.get('/ws/getTextoRGPD').then( result => {
					if(result.data.status == 0){
						commit('setTextRGPD',result.data.textoLargo);
						resolve(result.data.textoLargo);
					}else{
						commit('setError',result.data.status);
					}
				}).catch(error => {
					reject(false);
				});  				
			});	
		},
		acceptRGPD({dispatch}){
			return new Promise((resolve, reject) => {
				axios.get('/ws/aceptarRGPD').then( result => {
					if(result.data.status == 0){
						resolve(true);
						dispatch('turnOffRGPD');
					}else{
						commit('setError',result.data.status);
					}
				}).catch(error => {
					reject(false);
				});  				
			});	
		},
		requestPolitica(){
			return new Promise((resolve, reject) => {
				axios.get('/ws/getPoliticaPrivacidad').then( result => {
					resolve(result.data);
				}).catch(error => {
					reject(false);
				});  				
			});	
		},
		requestAvisoLegal(){
			return new Promise((resolve, reject) => {
				axios.get('/ws/getAvisoLegal').then( result => {
					resolve(result.data);
				}).catch(error => {
					reject(false);
				});  				
			});	
		},
	},
	mutations: {
		setRGPD(state,status){
			state.hasrpgd = status
		},
		setTextRGPD(state,text){
			
			state.textRGPD = text;
		}

	}
}

export default rgpdmodule;


// WEBPACK FOOTER //
// ./src/store/rgpdmodule.js